/**
 * This is the rsaConfirm controller.
 * @memberOf securityquestion Module
 * @namespace rsaConfirm Controller
 */

/**
 * @name rsaConfirmController
 * @desc Create the controller.
 * @param $scope
 * @param coreService
 * @memberOf securityquestion Module.rsaConfirm Controller
 * @ngInject
 */
function rsaConfirmController($scope, $translate, coreService) {
    var vm = this;
    // Confirm the view model's properties.
    vm.submitted = false;
    vm.messages = [];

    // Activate the controller.
    activate();

    function activate() {
        // Read Identity Server's data model
        var model = coreService.getIdentityModel();

        if (model.custom && model.custom.ui_locales) {
            $translate.use(model.custom.ui_locales);
        }

        if (!model.selectedQuestions) {
            model.selectedQuestions = [];
        }

        $scope.model = model;
    }
}

export default rsaConfirmController;


// WEBPACK FOOTER //
// ./src/login/securityquestion/rsa/confirm/rsa.confirm.controller.js